import { render } from "./PartGroupModal.vue?vue&type=template&id=1bcfbe8a"
import script from "./PartGroupModal.vue?vue&type=script&lang=js"
export * from "./PartGroupModal.vue?vue&type=script&lang=js"
script.render = render

export default script